import { useReducer } from 'react';

import { Form, message } from 'antd';

import type { AirdropRule } from '@api/index'
import { fetchAirdropRule } from '@api/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks'
import { I18n } from '@utils/index';

const reduce = (state: Partial<AirdropRule>, action: { type: 'update', payload: Partial<AirdropRule> }) => {
  switch (action.type) {
    case 'update':
      return { ...state, ...action.payload };
    default:
      throw new Error();
  }
}

export const FORM_KYYS = {
  /** 空投类型 FORTUNE 幸运空投 GENERAL 普通空投  */
  assignType: 'assignType',
  /** 空投币种 */
  currency: 'currency',
  /** 空投有效期 */
  validTime: 'validTime',
  /** 空投个数 */
  num: 'num',
  /** 空投金额 */
  amount: 'amount'
}

export const useMain = () => {
  const [form] = Form.useForm();
  const [rules, dispatch] = useReducer(reduce, {})

  const fetchInitData = async () => {
    try {
      const res = await fetchAirdropRule();
      if (!res.success) {
        message.error(I18n.t(res.msgKey));
        return;
      }
      dispatch({
        type: 'update',
        payload: {
          releaseNumMax: res.obj.releaseNumMax,
          receiveMin: res.obj.receiveMin,
          receiveMax: res.obj.receiveMax,
          releaseMax: res.obj.releaseMax,
          releaseMin: res.obj.releaseMin
        }
      })
    } catch (error) {

    }
  }

  useIsomorphicLayoutEffect(() => {
    fetchInitData();
  }, [])

  return {
    form,
    rules
  }
}
